import React, { useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import { useDataRequest } from '@ai4/data-request';

interface Props {
	show: boolean;
	selected: any;
	onCloseRemovePopup: () => void;
}

export function RemovePermissionPopup(props: Props) {
	const { selected, onCloseRemovePopup } = props;
	const { permission, role } = selected;
	const [show, setShow] = useState(props.show);
	const { useRestRequest } = useDataRequest();
	const [reqDel] = useRestRequest({
		path: 'api/{ver}/roles/{id}/permissions/{code}',
		method: 'DELETE',
		jwt: true,
	});

	const handleClose = () => {
		setShow(false);
	};

	const handleClosed = () => {
		onCloseRemovePopup();
	};

	const removePermission = async () => {
		try {
			await reqDel({
				path: `api/{ver}/roles/${role.id}/permissions/${permission.code}`,
			});
			alert(`Rimosso ${permission.name} da "${role.name}"`);
		} catch (e) {
			alert('Errore nel salvataggio');
		} finally {
			onCloseRemovePopup();
		}
	};

	return (
		<div>
			<Modal show={show} onHide={handleClose} onExited={handleClosed} size='xl'>
				<Modal.Header closeButton>
					<Modal.Title>Rimuovi permesso</Modal.Title>
				</Modal.Header>

				<Modal.Body>Vuoi rimuovere questo ruolo dal permesso?</Modal.Body>

				<Modal.Footer>
					<Button variant='secondary' onClick={handleClose}>
						Annulla
					</Button>
					<Button variant='primary' onClick={() => removePermission()}>
						Confermi
					</Button>
				</Modal.Footer>
			</Modal>
		</div>
	);
}

export default RemovePermissionPopup;
